export const instrumentationSchema = {
  scenario: [
    {
      name: 'loadCompetitionTab',
      value: 'LoadCompetitionTab',
      setting: {},
      activity: [
        {
          name: 'viewGeneralInsights',
          value: 'ViewGeneralInsights',
        },
        {
          name: 'viewDeeperInsights',
          value: 'ViewDeeperInsights',
        },
        // Below activities are for performance logs.
        {
          name: 'renderWithPreference',
          value: 'constructor to render after preference config is fetched from server',
        },
      ],
    }, {
      name: 'loadGeneralInsights',
      value: 'LoadGeneralInsightsInCompetitionTab',
      setting: {},
      activity: [
        // All trace logs will be under this activity.
        {
          name: 'loadGeneralInsights',
          value: 'LoadGeneralInsightsInCompetitionTab',
        },
        // Below activities are for performance logs.
        {
          name: 'mountChart',
          value: 'constructor to componentDidMount in chart',
        },
        {
          name: 'refreshChart',
          value: 'query of chart data source',
        },
        {
          name: 'findAll',
          value: 'non cached findAll of auction insight service',
        },
      ],
    }, {
      name: 'loadCompetitionRecommendation',
      value: 'LoadRecommendationInCompetitionTab',
      setting: {},
      activity: [
        // All trace logs will be under this activity.
        {
          name: 'loadCompetitionRecommendation',
          value: 'LoadRecommendationInCompetitionTab',
        },
        // Below activities are for performance logs.
        {
          name: 'getSummary',
          value: 'getsummary',
        },
        {
          name: 'getCoupons',
          value: 'getCoupons',
        },
        {
          name: 'getCount',
          value: 'getCount',
        },
        {
          name: 'track',
          value: 'track',
        },
      ],
    }],
};
